import React from "react";

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-10 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Company Info */}
        <div>
          <h3 className="text-xl font-bold mb-3">New Krishna Technology</h3>
          <p className="text-sm text-gray-300">
            We specialize in delivering robust networking, IT infrastructure, and security solutions for growing businesses.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-semibold mb-3 text-white">Quick Links</h4>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><a href="/" className="hover:text-accent">Home</a></li>
            <li><a href="/about" className="hover:text-accent">About</a></li>
            <li><a href="/services" className="hover:text-accent">Services</a></li>
            <li><a href="/contact" className="hover:text-accent">Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-semibold mb-3 text-white">Services</h4>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>Network Design</li>
            <li>Firewall & Security</li>
            <li>Cloud Backup</li>
            <li>IT Support (AMC)</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="font-semibold mb-3 text-white">Contact Us</h4>
          <p className="text-sm text-gray-300">
            📍 P. No. 2 balnath nager, jhotwara jaipur<br />
            📞 +91 9785442520<br />
            📞 +91 9887919299<br />
            📞 +91 8058971243<br />
            ✉️ support@nktinfo.com
          </p>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="mt-10 border-t border-white/10 pt-6 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} New Krishna Technology. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
